/**
 * Codes d'erreur Auth0 signifiant que la session est expiree et que seul
 * un logout/re-login peut la retablir. Partage par les interceptors de la
 * chaine HTTP — toute evolution doit s'appliquer aux deux.
 */
export const AUTH0_EXPIRED_ERRORS = ['login_required', 'consent_required', 'missing_refresh_token'];
